<template>
  <div class="managecode">
    <div class="campus">
      激活码管理
      <span>></span>管理码
    </div>
    <div class="xiaoqu moerduo">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-card>
            <div class="grid-content bg-purple scrollbarStyle treeStyle" style="height: 85vh; overflow: auto">
              <div class="xiaoqu_1  header">选择信息</div>

              <el-tree ref="tree" :data="data2" :highlight-current="true" @node-click="handleNodeClick" :props="props" node-key="id" :default-checked-keys="[bookid_1]" @check-change="dianxuan">
                <span class="span-ellipsis" slot-scope="{ node }">
                  <span :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
              <el-tree ref="tree1" :data="data3" :highlight-current="true" @node-click="handleNodeClick0" :props="props" node-key="id" :default-checked-keys="[bookid_2]" @check-change="dianxuan1">
                <span class="span-ellipsis" slot-scope="{ node }">
                  <span :title="node.label">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </el-card>
        </el-col>
        <el-col :span="19">
          <el-card>
            <div class="grid-content bg-purple scrollbarStyle shengchengma shifoushiyong" style="height: 85vh; overflow: auto">
              <div class="xiaoqu_1  header">管理码</div>
              <div class="dz-flex dz-flex-justify-space">
                <div class="criteria">
                  <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="swithStatus" active-text-color="#00ABEE" text-color="#666666">
                    <el-menu-item index="2" @click="selectActiveCodeList">已使用</el-menu-item>
                    <el-menu-item index="1" @click="selectActiveCodeList">未使用</el-menu-item>
                  </el-menu>
                </div>
                <div class="sousuo dz-flex dz-flex-align-center sousuo_wjj">
                  <span> 创建时间： </span>
                  <el-date-picker class="pickers" v-model="timetotime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                  <span class="ml-30">激活码：</span>
                  <el-input v-model="activecode" @keyup.13.native="selectActiveCodeList" placeholder="请输入详细的激活码查询"></el-input>
                  <el-button type="primary" class="buttons sousuo_wjj1 ml-30" @click="selectActiveCodeList">
                    查 询
                  </el-button>
                </div>
              </div>
              <div class="zsbg_1">
                <div class="zsbg tableStyle">
                  <el-table :data="tableData" border style="width: 100%">
                    <el-table-column prop="activecode" label="激活码"></el-table-column>
                    <el-table-column prop="bookname" label="教材"></el-table-column>
                    <el-table-column prop="orgname" label="学校"></el-table-column>
                    <el-table-column prop="create_date" label="使用时间"></el-table-column>
                    <el-table-column prop="username" label="使用学员"></el-table-column>
                  </el-table>
                </div>
                <div class="dz-flex dz-flex-justify-end mt-12">
                  <el-pagination class="fenye_jihuo" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[5, 10, 30, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Generating',
  data() {
    return {
      props: {
        children: 'children',
        label: 'label',
      },
      timetotime: '',
      jihuoma: '',
      data2: [],
      bookid_1: '',
      bookid_2: '',
      bookid_1label: '',
      bookid_2label: '',
      pageSize: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      data3: [],
      xuanzeyouxiaoqi: [],
      jhm_yxq: '',
      jhm_yxq1: '',
      jihuoma_shuliang: '',
      dialogTableVisibles: false,
      page: 1,
      status: 2,
      activecode: '',
      //已使用 未使用
      activeIndex: '2',
    };
  },
  watch: {
    timetotime() {
      this.selectActiveCodeList();
    },
    status(n) {
      if (n === 2) {
        this.selectActiveCodeList();
      }
      if (n === 1) {
        this.selectActiveCodeList();
      }
    },
  },
  created() {
    this.miniInfoSetting();
    this.getSchoolTree();
    this.selectActiveCodeList()
  },
  methods: {
    swithStatus(key) {
      this.status = key;
    },
    formateDate(datetime) {
      function addDateZero(num) {
        return num < 10 ? '0' + num : num;
      }
      let d = new Date(datetime);
      let formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate()) + ' ' + addDateZero(d.getHours()) + ':' + addDateZero(d.getMinutes()) + ':' + addDateZero(d.getSeconds());
      return formatdatetime;
    },

    dianxuan() {
      this.$refs.tree.setCheckedKeys([]);
    },
    dianxuan1() {
      this.$refs.tree1.setCheckedKeys([]);
    },
    handleNodeClick(data) {
      // console.log(data)
      if (data.type === 0) {
        this.bookid_1 = data.id;
        this.bookid_1label = data.label;
        // console.log(this.bookid_1)
        this.selectActiveCodeList();
      } else {
        this.bookid_1 = '';
        this.bookid_1label = '';
      }
    },

    handleNodeClick0(data) {
      // console.log(data)
      if (data.type === 0) {
        this.bookid_2 = data.id;
        this.bookid_2label = data.label;
        this.selectActiveCodeList();
      } else {
        this.bookid_2 = '';
        this.bookid_2label = '';
      }
    },

    // 查询激活码
    selectActiveCodeList() {
      let timetotime = this.timetotime;
      let fromtime = '';
      let totime = '';
      if (timetotime !== '' && timetotime !== null) {
        let size = timetotime.length;
        // console.log(size)
        if (size === 1) {
          fromtime = timetotime[0];
        } else if (size === 2) {
          fromtime = timetotime[0];
          totime = timetotime[1];
        }
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/activecode/selectActiveCodeList',
        method: 'POST',
        data: {
          bookid: this.bookid_1,
          schoolid: this.bookid_2,
          status: this.status,
          page: this.page,
          pageSize: this.pageSize,
          fromtime: fromtime,
          totime: totime,
          activecode: this.activecode,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].create_date = this.formateDate(this.tableData[i].create_date);
          }
          if (result.data.data === undefined || result.data.data === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询激活码失败：' + err);
        });
    },

    // 查询教材
    miniInfoSetting() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/book/getGroupTree/' + orgid,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.data2 = result.data.data;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询教材失败：' + err);
        });
    },

    // 查询校区
    getSchoolTree() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/org/getSchoolTree',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.data3 = result.data.data;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询校区失败：' + err);
        });
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      // this.$options.methods.chaxun()
      this.selectActiveCodeList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.selectActiveCodeList();
    },
  },
  destroyed() {},
};
</script>

<style lang="less" scoped>
.managecode {
  .xiaoqu {
    .shifoushiyong {
      .xiaoqu_1 {
        left: 0;
      }

      .jihuoma_shiyong {
        font-weight: bold;
        font-size: 20px;
        color: #333;
        margin-right: 45px;
      }
      .yishi {
        color: #00abee;
        padding-bottom: 10px;
        border-bottom: 3px solid #00abee;
      }
    }
    .grid-content {
      .xuan_shengcheng {
        margin-bottom: 35px;
      }
      .el-tree {
        margin-top: 10px;
      }
    }
    .sousuo {
      margin-bottom: 30px;
      .el-input {
        width: 200px;
      }
      .el-select {
        width: 110px;
      }
      .el-date-editor {
        width: 220px;
      }
    }
  }
}
</style>
